import * as Factory from 'factory.ts'
import faker from 'faker'

import { CardholderAccountStatuses } from '@webapp/modules/spending-cards/entities/enums/CardholderAccountStatusEnum'
import { IssuingProviders } from '@webapp/modules/spending-cards/entities/enums/IssuingProvider'
import { type CardholderApiModel } from '../CardholderApiModel'

export const CardholderApiModelStub =
  Factory.Sync.makeFactory<CardholderApiModel>({
    id: Factory.each(() => faker.random.number()),
    external_id: Factory.each(() => faker.random.uuid()),
    user_id: Factory.each(() => faker.random.number()),
    email: Factory.each(() => faker.internet.email()),
    first_name: Factory.each(() => faker.name.firstName()),
    last_name: Factory.each(() => faker.name.lastName()),
    department_id: Factory.each(() => faker.random.number()),
    profile_image: Factory.each(() => faker.image.avatar()),
    tos_accepted: true,
    status: CardholderAccountStatuses.ACTIVE,
    provider: IssuingProviders.AIRWALLEX,
  })
